import { render, staticRenderFns } from "./PpomBlocStat.vue?vue&type=template&id=0a7bfadc&scoped=true"
import script from "./PpomBlocStat.vue?vue&type=script&lang=js"
export * from "./PpomBlocStat.vue?vue&type=script&lang=js"
import style0 from "./PpomBlocStat.vue?vue&type=style&index=0&id=0a7bfadc&prod&lang=css"
import style1 from "./PpomBlocStat.vue?vue&type=style&index=1&id=0a7bfadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7bfadc",
  null
  
)

export default component.exports